export default __webpack_public_path__ + "static/5-4ab8b9a465567edea4cddcb60f9ade0a.webp";